import * as React from "react"
import {
    DataGrid,
} from "@mui/x-data-grid"
import axios from "axios"
import { send_authorized_request } from "../../Constants/cognito"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PercentIcon from '@mui/icons-material/Percent'
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"
import SearchIcon from '@mui/icons-material/Search';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';

import { useCookies } from "react-cookie"
import { AXIOS_API_INSTANCE } from "../../Constants"
import FeeModal from "./FeeModal"
import RentalCategoryModal from "./modals/RentalCategoryModal"
import { SimpleCustomToolbar } from "../CustomToolbar"
import { Box, Button, InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material"
import Grid from "@mui/material/Grid2"
import TabPanel from "../../Utils/tabpanel"
import RateGroupPage from "./RateGroupPage"
import RentalTypePage from "./RentalTypePage"
import { moneyFormat } from "../../Utils"

const SEARCH_LABEL = {
    "type": "Type",
    "category": "Category",
    "fee": "Fee",
    "rategroup": "Rate Group"
}
const SEARCH_TEXT = {
    "type": "Search Types",
    "category": "Search Categories",
    "fee": "Search Fees",
    "rategroup": "Search Rate Groups"
}

const rentalType_columns = [
    {
        field: "name",
        headerName: "Type",
        minWidth: 150,
        flex: 1,
        editable: false,
        filterable: false,
    },
    {
        field: "rental_category",
        headerName: "Category",
        minWidth: 150,
        flex: 1,
        editable: false,
        sortable: false,
        filterable: false,
        valueFormatter: (value) => {
            return value?.name || ""
        },
    },
    {
        field: "rental_rate_group",
        headerName: "Rate Group",
        minWidth: 210,
        flex: 1,
        editable: false,
        sortable: false,
        filterable: false,
        valueFormatter: (value) => {
            return value?.name || ""
        },
    },
    {
        field: "deposit",
        headerName: "Deposit",
        minWidth: 150,
        flex: 1,
        editable: false,
        filterable: false,
        renderCell: (params) => {
            if (params.row.deposit_calculation > 0) {
                if (params.row.deposit_type === 'PERCENTAGE') {
                    return <span><PercentIcon style={{ height: "16px", verticalAlign: 'text-bottom', marginRight: '-4px' }} />{params.row.deposit_calculation}</span>
                } else if (params.row.deposit_type === 'FLAT_RATE') {
                    return <span><AttachMoneyIcon style={{ height: "16px", verticalAlign: 'text-bottom', marginRight: '-6px' }} />{moneyFormat(params.row.deposit_calculation)}</span>
                } else if (params.row.deposit_type === 'FLAT_RATE_PER_ITEM') {
                    return <span><AttachMoneyIcon style={{ height: "16px", verticalAlign: 'text-bottom', marginRight: '-6px' }} />{moneyFormat(params.row.deposit_calculation)} per item</span>
                }
            } else {
                return (<span><AttachMoneyIcon style={{ height: "16px", verticalAlign: 'text-bottom' }} />0.00</span>)
            }
        }
    },
    {
        field: "fees",
        headerName: "Fees",
        minWidth: 210,
        flex: 1,
        editable: false,
        sortable: false,
        filterable: false,
        valueFormatter: (value) => {
            return (value ?? []).map((x) => x.name).sort().join(', ')
        },
    },
]
const rentalCategory_columns = [
    {
        field: "name",
        headerName: "Name",
        minWidth: 150,
        maxWidth: 400,
        flex: 1,
        editable: false,
        filterable: false,
    },
    {
        field: "description",
        headerName: "Description",
        minWidth: 150,
        flex: 1,
        editable: false,
        filterable: false,
    },
]

const fee_columns = [
    {
        field: "name",
        headerName: "Name",
        minWidth: 150,
        flex: 1,
        editable: false,
        filterable: false,
    },
    {
        field: "fee_type",
        headerName: "Type",
        minWidth: 150,
        flex: 1,
        editable: false,
        filterable: false,
        renderCell: (params) => {
            switch (params.row.fee_type) {
                case 'FLAT_RATE':
                    return "Flat Rate"
                case 'FLAT_RATE_PER_ITEM':
                    return "Flat Rate Per Bulk Item"
                case 'PERCENTAGE':
                    return "Percentage"
                default:
                // code block
            }
        }
    },
    {
        field: "calculation",
        headerName: "Calculation",
        minWidth: 210,
        flex: 1,
        editable: false,
        filterable: false,
        renderCell: (params) => {
            if (params.row.fee_type === 'PERCENTAGE') {
                return <span><PercentIcon style={{ height: "16px", verticalAlign: 'text-bottom', marginRight: '-4px' }} />{params.value}</span>
            } else if (params.row.fee_type === 'FLAT_RATE') {
                return <span><AttachMoneyIcon style={{ height: "16px", verticalAlign: 'text-bottom', marginRight: '-6px' }} />{moneyFormat(params.value)}</span>
            } else if (params.row.fee_type === 'FLAT_RATE_PER_ITEM') {
                return <span><AttachMoneyIcon style={{ height: "16px", verticalAlign: 'text-bottom', marginRight: '-6px' }} />{moneyFormat(params.value)} per item</span>
            }
        }
    },
    {
        field: 'refundable',
        headerName: 'Refundable?',
        minWidth: 110,
        flex: 1,
        editable: false,
        sortable: false,
        filterable: false,
        renderCell: (params) => { return params.value ? <CheckCircleIcon color='success' /> : <CancelIcon color='error' /> }
    },
    {
        field: 'optional',
        headerName: 'Required?',
        minWidth: 110,
        flex: 1,
        editable: false,
        sortable: false,
        filterable: false,
        renderCell: (params) => { return params.value ? <CancelIcon color='error' /> : <CheckCircleIcon color='success' /> }
    },
]

const rateGroup_columns = [
    {
        field: "name",
        headerName: "Name",
        minWidth: 150,
        maxWidth: 400,
        flex: 1,
        editable: false,
        filterable: false,
    },
    {
        field: "rental_rates",
        headerName: "Rates",
        minWidth: 150,
        flex: 1,
        editable: false,
        sortable: false,
        filterable: false,
        valueGetter: (params) => {
            if (
                params.row.rental_rates !== undefined &&
                params.row.rental_rates !== null
            ) {
                return params.row.rental_rates.map((rate) => {
                    return `${rate.name || ""}/${rate.time_unit || ""} ${rate.min_time || ""
                        }-${rate.max_time || ""} ${rate.time_unit || ""}\n`
                })
            } else {
                return ""
            }
        },
    },
]

function RentalConfigs(props) {
    const [cookies, setCookie] = useCookies(["pagination"])
    const [tab, setTab] = React.useState("type")
    const getTab = React.useRef(tab)
    const [categoriesPaginationModel, setCategoriesPaginationModel] = React.useState({
      pageSize: cookies.pagination?.rentalcategories_pageSize || 10,
      page: 0,
    });
    const [feesPaginationModel, setFeesPaginationModel] = React.useState({
      pageSize: cookies.pagination?.fees_pageSize || 10,
      page: 0,
    });
    const [rentalRatesPaginationModel, setRentalRatesPaginationModel] = React.useState({
      pageSize: cookies.pagination?.rentalrates_pageSize || 10,
      page: 0,
    });
    const [rentalTypesPaginationModel, setRentalTypesPaginationModel] = React.useState({
      pageSize: cookies.pagination?.rentaltypes_pageSize || 10,
      page: 0,
    });
    const [rowData, setRowData] = React.useState({ rows: [], total_count: 0 })
    const [rentalTypeSorting, setRentalTypeSorting] = React.useState({ field: 'id', sort: 'asc' })
    const [rentalCategorySorting, setRentalCategorySorting] = React.useState({ field: 'id', sort: 'asc' })
    const [feeSorting, setFeeSorting] = React.useState({ field: 'id', sort: 'asc' })
    const [rateGroupSorting, setRateGroupSorting] = React.useState({ field: 'id', sort: 'asc' })
    const [isLoading, setIsLoading] = React.useState(true)
    const [rentalTypePage, setRentalTypePage] = React.useState({
        open: false,
        rentalType: {},
        creatingNewRentalType: false,
    })
    const [rentalCategoryModal, setRentalCategoryModal] = React.useState({
        open: false,
        rentalCategory: {},
        creatingNewRentalCategory: false,
    })
    const [feeModal, setFeeModal] = React.useState({
        open: false,
        fee: {},
        creatingNewFee: false,
    })
    const [rateGroupPage, setRateGroupPage] = React.useState({
        open: false,
        rateGroup: undefined,
        creatingNewRateGroup: false,
    })
    const [search, setSearch] = React.useState('')

    const mySetTab = (tab) => {
        setRowData({ rows: [], total_count: 0 })
        getTab.current = tab;
        setSearch("")
        setTab(tab)
    }

    const createButtonClick = () => {
        switch (tab) {
            case "type":
                setRentalTypePage({
                    rentalType: { checkout_checkin_questions: [], fee_ids: [], fees: [] },
                    open: true,
                    creatingNewRentalType: true,
                })
                break;
            case "category":
                setRentalCategoryModal({
                    rentalCategory: {},
                    open: true,
                    creatingNewRentalCategory: true,
                })
                break;
            case "fee":
                setFeeModal({ fee: {}, open: true, creatingNewFee: true })
                break;
            case "rategroup":
                setRateGroupPage({
                    rateGroup: { rental_rates: [{ quantity: 1, rental_rates: [] }], name: '' },
                    open: true,
                    creatingNewRateGroup: true,
                })
                break;
            default:
        }
    }

    const rentalTypeRowClick = (params) => {
        setRentalTypePage({
            rentalType: params.row,
            loading: true,
            open: true,
            creatingNewRentalType: false,
        })
    }
    const closeRentalTypePageWithChanges = (changes) => {
        setRentalTypePage({
            ...rentalTypePage,
            open: false,
        })
        if (changes) {
            getRentalType(rentalTypesPaginationModel, rentalTypeSorting.field, rentalTypeSorting.sort, search)
        }
    }

    const rentalCategoryRowClick = (params) => {
        setRentalCategoryModal({
            rentalCategory: params.row,
            loading: true,
            open: true,
            creatingNewRentalCategory: false,
        })
    }
    const closeRentalCategoryModal = (changes) => {
        setRentalCategoryModal({
            ...rentalCategoryModal,
            open: false,
        })
        if (changes) {
            getRentalCategories(categoriesPaginationModel, rentalCategorySorting.field, rentalCategorySorting.sort, search)
        }
    }

    const feeRowClick = (params) => {
        setFeeModal({ fee: params.row, open: true, creatingNewFee: false })
    }
    const closeFeeModal = (changes) => {
        setFeeModal({ ...feeModal, open: false })
        if (changes) {
            getFees(feesPaginationModel, feeSorting.field, feeSorting.sort, search)
        }
    }

    const rateGroupRowClick = (params) => {
        setRateGroupPage({
            rateGroup: params.row,
            open: true,
            creatingNewRateGroup: false,
        })
    }
    const closeRateGroupPage = (changes) => {
        setRateGroupPage({ ...rateGroupPage, open: false })
        if (changes) {
            getRateGroups(rentalRatesPaginationModel, rateGroupSorting.field, rateGroupSorting.sort, search)
        }
    }

    const setMyPaginationModel = (page_attr, pagination_setter) => (model) => {
        setCookie(
            "pagination",
            { ...cookies.pagination, [page_attr]: model.pageSize },
            { path: "/" }
        )
        pagination_setter(model)
    }
    const updateSearch = (event) => {
        setSearch(event.target.value.trim())
        // if (event.target.value.trim() !== userSearch) {
        //     debouncedGetUsers(sorting.field, sorting.sort, filtering, event.target.value.trim())
        // }
    }

    const getRentalType = (rentalTypesPaginationModel, sortField, sortDirection, filterVar) => {
        setIsLoading(true)
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentaltype", {
                        params: {
                            page_num: rentalTypesPaginationModel.page,
                            page_size: rentalTypesPaginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(filterVar),
                            check_deletable: true
                        },
                    }),
                ])
                .then(
                    axios.spread((type) => {
                        console.log(type)
                        if (getTab.current === 'type') {
                            for (const t of type.data.data) {
                                t.fee_ids = t.fees.map((fee) => fee.id)
                            }
                            setRowData({
                                rows: type.data.data,
                                total_count: type.data.total_count,
                            })
                            setIsLoading(false)
                        }
                    })
                )
        )
    }
    const getRentalCategories = (categoriesPaginationModel, sortField, sortDirection, filterVar) => {
        setIsLoading(true)
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalcategories", {
                        params: {
                            page_num: categoriesPaginationModel.age,
                            page_size: categoriesPaginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(filterVar),
                            check_deletable: true
                        },
                    }),
                ])
                .then(
                    axios.spread((customer) => {
                        console.log(customer)
                        if (getTab.current === 'category') {
                            setRowData({
                                rows: customer.data.data,
                                total_count: customer.data.total_count,
                            })
                            setIsLoading(false)
                        }
                    })
                )
        )
    }

    const getFees = (feesPaginationModel, sortField, sortDirection, filterVar) => {
        setIsLoading(true)
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("fees", {
                        params: {
                            page_num: feesPaginationModel.page,
                            page_size: feesPaginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(filterVar),
                            check_deletable: true
                        },
                    }),
                ])
                .then(
                    axios.spread((fee) => {
                        console.log(fee)
                        if (getTab.current === 'fee') {
                            setRowData({
                                rows: fee.data.data,
                                total_count: fee.data.total_count,
                            })
                            setIsLoading(false)
                        }
                    })
                )
        )
    }

    const getRateGroups = (rentalRatesPaginationModel, sortField, sortDirection, filterVar) => {
        setIsLoading(true)
        send_authorized_request(() =>
            axios
                .all([
                    AXIOS_API_INSTANCE.get("rentalrategroups", {
                        params: {
                            page_num: rentalRatesPaginationModel.page,
                            page_size: rentalRatesPaginationModel.pageSize,
                            order_by: sortField,
                            order_by_direction: sortDirection,
                            filters: JSON.stringify(filterVar),
                            check_deletable: true
                        },
                    }),
                ])
                .then(
                    axios.spread((rateGroup) => {
                        console.log(rateGroup)
                        if (getTab.current === 'rategroup') {
                            setRowData({
                                rows: rateGroup.data.data,
                                total_count: rateGroup.data.total_count,
                            })
                            setIsLoading(false)
                        }
                    })
                )
        )
    }

    React.useEffect(() => {
        if (tab === "type") {
            return getRentalType(rentalTypesPaginationModel, rentalTypeSorting.field, rentalTypeSorting.sort, search)
        } else if (tab === "category") {
            return getRentalCategories(categoriesPaginationModel, rentalCategorySorting.field, rentalCategorySorting.sort, search)
        } else if (tab === "fee") {
            return getFees(feesPaginationModel, feeSorting.field, feeSorting.sort, search)
        } else if (tab === "rategroup") {
            return getRateGroups(rentalRatesPaginationModel, rateGroupSorting.field, rateGroupSorting.sort, search)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab, rentalTypesPaginationModel, categoriesPaginationModel, feesPaginationModel, rentalRatesPaginationModel,
        rentalTypeSorting, rentalCategorySorting, feeSorting, rateGroupSorting])

    return (
        (<React.Fragment>
            <Grid container space={1}>
                <Grid size="grow">
                    {!rateGroupPage.open && !rentalTypePage.open &&
                        <Box>
                            <Grid container sx={{ padding: "0" }} alignItems="center">
                                <Grid size="grow">
                                    <TextField
                                        sx={{ margin: 0 }}
                                        margin="dense"
                                        id="search"
                                        label={SEARCH_TEXT[tab]}
                                        type="text"
                                        variant="filled"
                                        disabled={isLoading}
                                        value={search}
                                        onChange={updateSearch}
                                        slotProps={{
                                            input: {
                                                inputProps: { min: 1 },
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        {<SearchIcon />}
                                                    </InputAdornment>
                                                ),
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid size="grow">
                                    <ToggleButtonGroup
                                        color="primary"
                                        value={tab}
                                        exclusive
                                        onChange={(e, newValue) => mySetTab(newValue)}
                                        aria-label="tab"
                                    >
                                        <ToggleButton value="type">Type</ToggleButton>
                                        <ToggleButton value="category">Category</ToggleButton>
                                        <ToggleButton value="rategroup">Rate Group</ToggleButton>
                                        <ToggleButton value="fee">Fee</ToggleButton>
                                    </ToggleButtonGroup>
                                </Grid>
                                <Grid sx={{ minWidth: '200px' }} size="auto">
                                    <Button onClick={createButtonClick} variant="contained" color="primary"><AddCircleSharpIcon /><Box sx={{ pl: 1 }}>Add {SEARCH_LABEL[tab]}</Box></Button>
                                </Grid>
                            </Grid>
                            <TabPanel value={tab} value_key={"type"} sx={{ p: 0, pt: '5px' }}>
                                <DataGrid
                                    slots={{
                                        toolbar: () => SimpleCustomToolbar(),
                                    }}
                                    rows={rowData.rows}
                                    rowCount={rowData.total_count}
                                    columns={rentalType_columns}
                                    disableRowSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                    autoHeight={true}
                                    filterMode={"server"}
                                    loading={isLoading}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    pagination
                                    paginationMode="server"
                                    paginationModel={rentalTypesPaginationModel}
                                    onPaginationModelChange={setMyPaginationModel('rentaltypes_pageSize', setRentalTypesPaginationModel)}
                                    onRowClick={rentalTypeRowClick}
                                    onSortModelChange={(params) => {
                                        if (params[0] !== undefined) {
                                            setRentalTypeSorting(params[0])
                                        } else {
                                            setRentalTypeSorting({ field: 'id', sort: 'asc' })
                                        }
                                    }}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"category"} sx={{ p: 0, pt: '5px' }}>
                                <DataGrid
                                    slots={{
                                        toolbar: () => SimpleCustomToolbar(),
                                    }}
                                    rows={rowData.rows}
                                    rowCount={rowData.total_count}
                                    columns={rentalCategory_columns}
                                    disableRowSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                    autoHeight={true}
                                    filterMode={"server"}
                                    loading={isLoading}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    pagination
                                    paginationMode="server"
                                    paginationModel={categoriesPaginationModel}
                                    onPaginationModelChange={setMyPaginationModel('rentalcategories_pageSize', setCategoriesPaginationModel)}
                                    onRowClick={rentalCategoryRowClick}
                                    onSortModelChange={(params) => {
                                        if (params[0] !== undefined) {
                                            setRentalCategorySorting(params[0])
                                        } else {
                                            setRentalCategorySorting({ field: 'id', sort: 'asc' })
                                        }
                                    }}
                                />
                                <RentalCategoryModal
                                    open={rentalCategoryModal.open}
                                    rental_category={rentalCategoryModal.rentalCategory}
                                    fees={rentalCategoryModal.fees}
                                    closeModal={closeRentalCategoryModal}
                                    creatingNewRentalCategory={rentalCategoryModal.creatingNewRentalCategory}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"fee"} sx={{ p: 0, pt: '5px' }}>
                                <DataGrid
                                    slots={{
                                        toolbar: () => SimpleCustomToolbar(),
                                    }}
                                    rows={rowData.rows}
                                    rowCount={rowData.total_count}
                                    columns={fee_columns}
                                    disableRowSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                    autoHeight={true}
                                    filterMode={"server"}
                                    loading={isLoading}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    pagination
                                    paginationMode="server"
                                    paginationModel={feesPaginationModel}
                                    onPaginationModelChange={setMyPaginationModel('fees_pageSize', setFeesPaginationModel)}
                                    onRowClick={feeRowClick}
                                    onSortModelChange={(params) => {
                                        if (params[0] !== undefined) {
                                            setFeeSorting(params[0])
                                        } else {
                                            setFeeSorting({ field: 'id', sort: 'asc' })
                                        }
                                    }}
                                />
                                {feeModal.open &&
                                    <FeeModal
                                        open={feeModal.open}
                                        fee={feeModal.fee}
                                        closeModal={closeFeeModal}
                                        creatingNewFee={feeModal.creatingNewFee}
                                    />
                                }
                            </TabPanel>
                            <TabPanel value={tab} value_key={"rategroup"} sx={{ p: 0, pt: '5px' }}>
                                <DataGrid
                                    slots={{
                                        toolbar: () => SimpleCustomToolbar()
                                    }}
                                    rows={rowData.rows}
                                    rowCount={rowData.total_count}
                                    columns={rateGroup_columns}
                                    disableRowSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                    autoHeight={true}
                                    filterMode={"server"}
                                    loading={isLoading}
                                    pageSizeOptions={[5, 10, 25, 50, 100]}
                                    pagination
                                    paginationMode="server"
                                    paginationModel={rentalRatesPaginationModel}
                                    onPaginationModelChange={setMyPaginationModel('rentalrates_pageSize', setRentalRatesPaginationModel)}
                                    onRowClick={rateGroupRowClick}
                                    onSortModelChange={(params) => {
                                        if (params[0] !== undefined) {
                                            setRateGroupSorting(params[0])
                                        } else {
                                            setRateGroupSorting({ field: 'id', sort: 'asc' })
                                        }
                                    }}
                                />
                            </TabPanel>
                        </Box>
                    }
                    {rateGroupPage.open &&
                        <RateGroupPage
                            rateGroup={rateGroupPage.rateGroup}
                            creatingNewRateGroup={rateGroupPage.creatingNewRateGroup}
                            closeFunction={closeRateGroupPage}
                        />
                    }
                    {rentalTypePage.open &&
                        <RentalTypePage
                            rentalType={rentalTypePage.rentalType}
                            creatingNewRentalType={rentalTypePage.creatingNewRentalType}
                            closeFunction={closeRentalTypePageWithChanges}
                        />
                    }
                </Grid>
            </Grid>
        </React.Fragment >)
    );
}

export default RentalConfigs
